import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";

import {
    JiraOverlayTemplate,
    LayoutVersion
} from "@/components/signup/layouts";
import { featureFlags } from "@/utils/feature-flags";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";

export const JiraOverlayShim = ({ children }: PropsWithChildren) => {
    const modalVisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    const version = modalVisualUpdates ? LayoutVersion.V3 : LayoutVersion.V1;

    return (
        <JiraOverlayTemplate size="lg" version={version}>
            <div
                css={[
                    jiraOverlayShimCss,
                    modalVisualUpdates && jiraOverlayShimVisualUpdateCss
                ]}
            >
                {children}
            </div>
        </JiraOverlayTemplate>
    );
};

const jiraOverlayShimVisualUpdateCss = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["& > div"]: {
        paddingBlockStart: 0
    }
});

const jiraOverlayShimCss = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    ["& > div"]: {
        paddingBlockStart: 16,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        ["> div:first-of-type"]: {
            [media.above.sm]: {
                paddingInlineStart: 0,
                paddingBlock: 0
            }
        }
    }
});
